var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2539 35.7284V18.6669M19.2539 9.18834H11.5762C6.32508 9.18834 6.00281 1.60547 11.5762 1.60547C17.5477 1.60547 19.2539 9.18834 19.2539 9.18834ZM19.2539 9.18834H26.9315C32.4215 9.18834 32.4215 1.60547 26.9315 1.60547C20.96 1.60547 19.2539 9.18834 19.2539 9.18834Z",
    stroke: "#21D868",
    strokeWidth: 2.84358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4182 18.6666V31.9366C34.4182 32.9422 34.0188 33.9065 33.3077 34.6176C32.5967 35.3286 31.6323 35.7281 30.6268 35.7281H7.87817C6.87261 35.7281 5.90825 35.3286 5.19721 34.6176C4.48618 33.9065 4.08673 32.9422 4.08673 31.9366V18.6666M36.314 18.6666V12.9794C36.314 11.9739 35.9145 11.0095 35.2035 10.2985C34.4924 9.58744 33.5281 9.18799 32.5225 9.18799H5.98245C4.9769 9.18799 4.01253 9.58744 3.3015 10.2985C2.59046 11.0095 2.19101 11.9739 2.19101 12.9794V18.6666H36.314Z",
    stroke: "#21D868",
    strokeWidth: 2.84358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.376983c865818402679609fdac72a42a.svg";
export { ForwardRef as ReactComponent };